import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-overlay-header',
  template: '<ng-content />',
  styleUrls: ['./overlay-header.component.scss']
})
export class OverlayHeaderComponent {}
